
export function getCompanyStatusString(record){
  if(record.isApproved) return 'Active'
  if(record.isRejected) return 'Inactive'
  return 'Pending'
}
